import React from 'react';
import { useSelector } from 'react-redux';
import { IInititalState } from '../../../reducers/mainReducer';
import { useAuth } from '../../../contexts/AuthContext';
import { If } from '../../If/If';
import { Container, Content, ContentBody, SessionExpiringMessage } from './styles';

interface IPageProps {
  header?: React.ReactNode;
  contentHeader?: React.ReactNode;
  contentFooter?: React.ReactNode;
  footer?: React.ReactNode;
}

export const Page: React.FC<IPageProps> = ({
  children,
  header,
  contentHeader,
  contentFooter,
  footer
}) => {

  const { session } = useAuth();

  const [dimensions, setDimensions] = React.useState({
    screenHeight: window.screen.height,
    windowHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  });

  const {
    sessionIsExpiring
  } = useSelector<{ main: IInititalState }, {
    sessionIsExpiring?: boolean
  }>(state => {
    return {
      sessionIsExpiring: state.main.sessionIsExpiring
    }
  });

  React.useEffect(() => {
    function handleResize() {
      setTimeout(() => setDimensions({
        screenHeight: window.screen.height,
        windowHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      }), 100);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  const sessionExpirationBlock = React.useMemo(() => {
    if (session && sessionIsExpiring) {
      return (
        <SessionExpiringMessage>
          A sessão atual vai expirar em breve. Termine o seu trabalho atual e faça login novamente para evitar problemas.
        </SessionExpiringMessage>
      )
    }
    if (sessionIsExpiring) {
      return (
        <SessionExpiringMessage>
          A sessão expirou.
        </SessionExpiringMessage>
      )
    }
    return null;
  }, [session, sessionIsExpiring]);

  return (
    <Container data-name="page-container" height={`${dimensions.windowHeight - 10}px`}>
      {sessionExpirationBlock}
      <Content data-name="header" backgroundColor='#fff'>
        <ContentBody data-name="content-header">
          {header}
        </ContentBody>
      </Content>
      <If condition={!!contentHeader}>
        <Content>
          <ContentBody>
            {contentHeader}
          </ContentBody>
        </Content>
      </If>
      <Content data-name="body" style={{ flex: '1', overflowY: 'auto' }}>
        <ContentBody data-name="content-body">
          {children}
        </ContentBody>
      </Content>
      <If condition={!!contentFooter}>
        <Content data-name="footer">
          <ContentBody data-name="content-footer">
            {contentFooter}
          </ContentBody>
        </Content>
      </If>
      <If condition={!!footer}>
        <Content data-name="footer" backgroundColor='#fff'>
          <ContentBody data-name="content-footer">
            {footer}
          </ContentBody>
        </Content>
      </If>
    </Container>
  );
}